import { useEffect, useState } from "react";
import api from "@/lib/api";
import TierBadge from "@/components/tier-badge";
import { formatDateTime } from "@/lib/date";

export default function StaffAmbassadors() {
  const [users, setUsers] = useState([]);
  useEffect(() => { api.get("/staff/ambassadors").then((r) => setUsers(r.data)).catch(() => {}); }, []);

  return (
    <div className="space-y-6">
      <h1 className="font-serif-display text-4xl">My Ambassadors</h1>
      <div className="rounded-2xl bg-white/5 border border-white/10 overflow-hidden">
        {users.length === 0 ? (
          <div className="p-10 text-center text-sm text-white/60">No ambassadors assigned yet.</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="text-xs uppercase tracking-widest text-white/50 border-b border-white/10">
              <tr>
                <th className="text-left p-4">Name</th>
                <th className="text-left p-4">Email</th>
                <th className="text-left p-4">Ref code</th>
                <th className="text-left p-4">Level</th>
                <th className="text-left p-4">Qualified / Total</th>
                <th className="text-left p-4">Registered</th>
                <th className="text-left p-4">Status</th>
              </tr>
            </thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.id} data-testid={`staff-amb-row-${u.id}`} className="border-b border-white/5 last:border-0">
                  <td className="p-4">{u.name} {u.surname}</td>
                  <td className="p-4 text-white/70">{u.email}</td>
                  <td className="p-4 font-mono text-xs">{u.ref_code}</td>
                  <td className="p-4"><TierBadge level={u.level || "Starter"} size="sm" /></td>
                  <td className="p-4">{u.qualified_count} / {u.total_referrals}</td>
                  <td className="p-4 text-xs text-white/70">{formatDateTime(u.created_at)}</td>
                  <td className="p-4"><span className={`px-2 py-1 rounded-full text-xs ${u.status === "active" ? "bg-[#f4a261]/20 text-[#f4a261]" : "bg-red-500/20 text-red-300"}`}>{u.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
